export enum AddressTypeEnum {
  BILLING = 1,
  CONTACT = 2,
  ORDER = 3,
}
